import React from 'react';

function PdfDisplay() {
  return <div>PdfDisplay</div>;
}

export default PdfDisplay;
